module.exports = __webpack_public_path__ + "img/cover.4efaf9bc.jpg";